module.exports = __webpack_public_path__ + "static/media/UE.d36b4e79.svg";